import { Navigate } from 'react-router-dom';

const LoginRoute = ({ isAuth, children }) => {
  if (isAuth) {
    return <Navigate to="/users" replace />;
  }

  return children;
};

export default LoginRoute;
